import { Button } from "@/shared/ui/button";
import { type Severity, SEVERITIES } from "../types";

const LABEL: Record<Severity, string> = { critical: "Critical", high: "High", medium: "Medium", low: "Low" };

export function SeverityPicker({ onPick, disabled }: { onPick: (s: Severity) => void; disabled?: boolean }) {
  return (
    <div className="flex flex-wrap gap-2">
      {SEVERITIES.map((s) => (
        <Button key={s} type="button" variant="outline" size="sm" disabled={disabled} onClick={() => onPick(s)}>
          {LABEL[s]}
        </Button>
      ))}
    </div>
  );
}
